import { useQuery } from "@tanstack/react-query";
import firmwareKlydosClient from "../../../api/firmware-klydos";

const useFirmwareKlydosQuery = () => {
  return useQuery({
    queryKey: ["firmware-klydos"],
    queryFn: () => firmwareKlydosClient.getAllFirmwareKlydos(),
  });
};

export default useFirmwareKlydosQuery;
